/**
 * Descarga un string CSV (ej. separado por | o ,)
 * @param csvString Texto en formato CSV
 * @param filename Nombre del archivo a guardar
 */
export const downloadCSVFromString = (csvString, filename = "data.csv") => {
    const blob = new Blob([csvString], { type: "text/csv;charset=utf-8;" });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.setAttribute("download", filename);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
};
